import { Component, OnInit } from '@angular/core';
import { LazyLoadEvent, MessageService, SelectItem, Table } from 'primeng';
import { VehicleLifecycleService } from '../../services/vehicle-lifecycle.service';
import { IVehicleStatusOverviewDTO } from '../../interfaces/vehicle-life-cycle/vehicle-status-overview';
import { Subject } from 'rxjs';
import { IVehicleLifeCycleStatusFilter } from '../../interfaces/vehicle-life-cycle/vehicle-life-cycle-status-filter';
import { IPageResult } from '../../interfaces/page-result';
import { IVehicleLifeCycleStatusDetailsDTO } from '../../interfaces/vehicle-life-cycle/vehicle-life-cycle-status-details';
import { debounceTime } from 'rxjs/operators';
import { Message } from '../../classes/Message';
import FileSaver from 'file-saver';
import { ITaskInfo } from '../../interfaces/task-info';
import { MapService } from '../../services';
import { IVehicleLifeCycleAdditionalOrderInfo } from '../../interfaces/vehicle-life-cycle/vehicle-life-cycle-additional-order-info';
import { ConfirmationService } from 'primeng';
import { IVehicleLifeCycleSiteStatus } from '../../interfaces/vehicle-life-cycle/vehicle-life-cycle-site-status';
import { IVehicleLifeCycleSiteDetails } from '../../interfaces/vehicle-life-cycle/vehicle-life-cycle-site-details';

@Component({
  selector: 'app-vehicle-lifecycle',
  templateUrl: './vehicle-lifecycle.component.html',
  styleUrls: ['./vehicle-lifecycle.component.css'],
})
export class VehicleLifecycleComponent implements OnInit {
  public isDownloading: boolean = false;
  public isLoadingOverviewCounts: boolean = false;

  public isLoaded: boolean = false;
  public isLoading: boolean = false;

  public filterVal: IVehicleLifeCycleStatusFilter;
  public filter: Subject<IVehicleLifeCycleStatusFilter>;

  public page: IPageResult<IVehicleLifeCycleStatusDetailsDTO> = {
    items: [],
    total: 0,
  };

  private statusIcons: { key: string; url: string; description: string }[] = [
    {
      key: 'checked-in',
      url: '/assets/images/icons/svg/vehicle-lifecycle/status_checked-in.svg',
      description: 'The vehicle has been checked in to a refurb site, and is awaiting estimate.',
    },
    {
      key: 'en-route',
      url: '/assets/images/icons/svg/vehicle-lifecycle/status_en-route.svg',
      description: 'The vehicle is on route',
    },
    {
      key: 'pending-estimate',
      url: '/assets/images/icons/svg/vehicle-lifecycle/status_pending-estimate.svg',
      description: 'The vehicle is awaiting a re-estimate',
    },
    {
      key: 'refurb-completed',
      url: '/assets/images/icons/svg/vehicle-lifecycle/status_refurb-completed.svg',
      description: 'The vehicle refurb has been completed.',
    },
    {
      key: 'refurb-progress',
      url: '/assets/images/icons/svg/vehicle-lifecycle/status_refurb-progress.svg',
      description: 'The vehicle refurb is being carried out.',
    },
    {
      key: 'released',
      url: '/assets/images/icons/svg/vehicle-lifecycle/status_released.svg',
      description: 'The vehicle has been released.',
    },
  ];

  public teams: SelectItem[] = [];
  public vehicleMakes: SelectItem[] = [];
  public vehicleModels: SelectItem[] = [];
  public customerSites: SelectItem[] = [];

  refurbOptions: SelectItem[] = [
    { label: 'Checked In', value: 'CHECKEDIN' },
    { label: 'Checked Out', value: 'CHECKOUT' },
    { label: 'En Route', value: 'ONROUTE' },
    { label: 'Engineius Requested', value: 'ENGINEIUSREQUESTED' },
    { label: 'Estimate Approved', value: 'ESTIMATEAPPROVED' },
    { label: 'Estimate Rejected', value: 'REJECTED' },
    { label: 'Estimated Off Site', value: 'ESTIMATEDOFFSITE' },
    { label: 'Pending Est. Approval', value: 'ESTIMATED' },
    { label: 'Pending Estimate', value: 'RE-ESTIMATEREQUIRED' },
    { label: 'Refurb Completed', value: 'COMPLETED' },
    { label: 'Refurb In Progress', value: 'INPROCESS' },
    { label: 'Released', value: 'RELEASED' },
  ];

  pillOptions = [
    {
      key: 'CHECK OUT',
      class: 'pill-check-out',
      displayLabel: 'Checked Out',
      displayDescription: 'The vehicle has been checked out and is no longer on site.',
    },
    {
      key: 'CHECKED IN',
      class: 'pill-checked-in',
      displayLabel: 'Checked In',
      displayDescription:
        'The vehicle has been checked in to a refurb site, and is awaiting estimate.',
    },
    {
      key: 'COMPLETED',
      class: 'pill-completed',
      displayLabel: 'Refurb Completed',
      displayDescription: 'The vehicle refurb has been completed.',
    },
    {
      key: 'ESTIMATED',
      class: 'pill-estimated',
      displayLabel: 'Pending Est. Approval',
      displayDescription: 'The vehicle has been estimated, and is awaiting approval.',
    },
    {
      key: 'ESTIMATED OFFSITE',
      class: 'pill-estimated-offsite',
      displayLabel: 'Estimated Off Site',
      displayDescription: 'The vehicle was estimated offsite and it not onsite yet',
    },
    {
      key: 'ESTIMATE APPROVED',
      class: 'pill-estimate-approved',
      displayLabel: 'Estimate Approved',
      displayDescription: 'The estimate has been approved, the vehicle is awaiting refurb.',
    },
    {
      key: 'IN PROCESS',
      class: 'pill-in-process',
      displayLabel: 'Refurb In Progress',
      displayDescription: 'The vehicle refurb is being carried out.',
    },
    {
      key: 'ON ROUTE',
      class: 'pill-on-route',
      displayLabel: 'En Route',
      displayDescription: 'The vehicle is on route',
    },
    {
      key: 'RE-ESTIMATE REQUIRED',
      class: 'pill-re-estimate-required',
      displayLabel: 'Pending Estimate',
      displayDescription: 'The vehicle is awaiting a re-estimate',
    },
    {
      key: 'REJECTED',
      class: 'pill-rejected',
      displayLabel: 'Estimate Rejected',
      displayDescription: 'The estimate has been rejected.',
    },
    {
      key: 'RELEASED',
      class: 'pill-released',
      displayLabel: 'Released',
      displayDescription: 'The vehicle has been released.',
    },
    {
      key: 'ENGINEIUS REQUESTED',
      class: 'pill-on-route',
      displayLabel: 'Engineius Requested',
      displayDescription:
        'An order has been created to a refurb site; however, we have not yet had any detail of this refurb from the fleet service.',
    },
  ];

  overviewCounts: IVehicleStatusOverviewDTO;
  siteStatusOverview: IVehicleLifeCycleSiteStatus[];
  siteDetails: IVehicleLifeCycleSiteDetails[];
  groupedSiteDetails: { [key: string]: IVehicleLifeCycleSiteDetails[] } = {};

  public orderInfoVisible: boolean;
  public additionalOrderInfo: IVehicleLifeCycleAdditionalOrderInfo;
  public mapLoading: boolean = false;
  public mapLink: string;
  public siteDetailsVisible: boolean;

  constructor(
    public vehicleLifeCycleService: VehicleLifecycleService,
    public messageService: MessageService,
    private mapService: MapService,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit(): void {
    this.initDefaultFilters();

    this.filter = new Subject<IVehicleLifeCycleStatusFilter>();

    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    this.filter.next(this.filterVal);

    this.loadTeamDropDownItems().then((teams) => (this.teams = teams));

    this.loadVehicleMakeDropDownItems().then((vehicleMakes) => (this.vehicleMakes = vehicleMakes));

    this.loadCustomerSiteDropDownItems().then(
      (customerSites) => (this.customerSites = customerSites),
    );

    this.getOverviewCounts();
    this.getSiteStatusOverview();
  }

  initDefaultFilters() {
    const refurbStatusValues = this.refurbOptions
      .filter((x) => x.value != 'CHECKOUT')
      .map((option) => option.value);

    this.filterVal = <IVehicleLifeCycleStatusFilter>{
      first: 0,
      rows: 5,
      sortField: 'RESET',
      sortOrder: 1,
      filters: {
        vehicleReg: {},
        sites: { value: null },
        teams: { value: null },
        refurbStatuses: { value: refurbStatusValues },
        vehicleMakes: { value: null },
        vehicleModels: { value: null },
      },
    };

    this.vehicleModels = [];
  }

  getStatusIconUrl(key: string): string | undefined {
    const icon = this.statusIcons.find((icon) => icon.key === key);
    return icon ? icon.url : undefined;
  }

  getStatusWidgetDescription(key: string): string | undefined {
    const desc = this.statusIcons.find((status) => status.key === key);
    return desc ? desc.description : undefined;
  }

  getOverviewCounts(): void {
    this.isLoadingOverviewCounts = true;
    this.vehicleLifeCycleService.getOverviewCounts().then((overviewCounts) => {
      this.overviewCounts = overviewCounts;
      this.isLoadingOverviewCounts = false;
    });
  }

  load(filterCommand: IVehicleLifeCycleStatusFilter): void {
    this.isLoading = true;
    this.vehicleLifeCycleService.getVehicleStatusDetails(filterCommand).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
      this.isLoading = false;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent): void {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;
    this.filter.next(this.filterVal);
  }

  resetFilters(dt: Table): void {
    dt.rows = 5;
    this.initDefaultFilters();
    this.filter.next(this.filterVal);
  }

  search(): void {
    this.filterVal.first = 0;
    this.filter.next(this.filterVal);
  }

  public getPillClass(status: string): any {
    return this.pillOptions.filter((x) => x.key == status)[0];
  }

  public convertMinutesToDaysHours(minutes: number): string {
    if (minutes < 1440) {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      return `<strong>${hours}</strong> Hours <strong>${remainingMinutes}</strong> Minutes`;
    } else {
      const days = Math.floor(minutes / 1440);
      const remainingMinutes = minutes % 1440;
      const hours = Math.floor(remainingMinutes / 60);
      return `<strong>${days}</strong> Days <strong>${hours}</strong> Hours`;
    }
  }

  public timeSince(queryDate: string): string {
    const filterDate = new Date(queryDate);
    const now = new Date();
    const diffInMilliseconds = now.getTime() - filterDate.getTime();
    const diffInMinutes = diffInMilliseconds / 1000 / 60;
    const diffInHours = Math.floor(diffInMinutes / 60);

    if (diffInHours < 1) {
      return `< 1 hr`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hrs`;
    } else {
      const days = Math.floor(diffInHours / 24);
      const remainingHours = Math.floor(diffInHours % 24);
      return `${days} days ${remainingHours} hrs`;
    }
  }

  navigateToJobScreen(jobId: number, orderId: number): void {
    if (jobId == 0 || orderId == 0) return;

    const url = `app/jobscreen/${jobId}/${orderId}`;
    window.open(url, '_blank');
  }

  loadTeamDropDownItems(): Promise<SelectItem[]> {
    return this.vehicleLifeCycleService.getTeams();
  }

  loadVehicleMakeDropDownItems(): Promise<SelectItem[]> {
    return this.vehicleLifeCycleService.getVehicleMakes();
  }

  loadVehicleModelDropDownItems(): Promise<SelectItem[]> {
    return this.vehicleLifeCycleService.getVehicleModels(this.filterVal.filters.vehicleMakes.value);
  }

  loadCustomerSiteDropDownItems(): Promise<SelectItem[]> {
    return this.vehicleLifeCycleService.getActiveCustomerSites();
  }

  onVehicleMakeChange(): void {
    this.loadVehicleModelDropDownItems().then((vehicleModels) => {
      this.vehicleModels = vehicleModels;
      this.filterVal.filters.vehicleModels.value =
        this.filterVal.filters.vehicleModels.value.filter((vm) =>
          this.vehicleModels.some((nvm) => nvm.value === vm),
        );
    });
  }

  downloadReport(): void {
    this.isDownloading = true;
    this.vehicleLifeCycleService.downloadReport(this.filterVal).subscribe(
      (x) => this.handleDownloadFile(x, 'VehicleLifeCycleReport.csv'),
      (error) => {
        this.messageService.add(
          Message.Error('An error occurred when attempting to download the requested report.'),
        );
        this.isDownloading = false;
      },
      () => {
        this.messageService.add(
          Message.Success('Download successful. Check your download folder.'),
        );
        this.isDownloading = false;
      },
    );
  }

  private handleDownloadFile(blob, fileName) {
    FileSaver.saveAs(blob, fileName);
  }

  createOrder(refurb: IVehicleLifeCycleStatusDetailsDTO, bypass: boolean = false): void {
    if (refurb.refurbId == 0) return;

    if (refurb.refurbStatus != 'COMPLETED' && bypass == false) {
      this.confirmationService.confirm({
        header: 'Warning: Vehicle Status Alert',
        message:
          "This vehicle is not in the 'Refurb Completed' status. It may not yet be ready for movement. Do you wish to continue with the movement booking?",
        accept: () => {
          this.createOrder(refurb, true);
        },
      });
      return;
    }

    const url = `app/job/create/1?vlcRefurbId=${encodeURIComponent(refurb.refurbId)}`;
    window.open(url, '_blank');
  }

  showOrderInfo(lifeCycleRow: IVehicleLifeCycleStatusDetailsDTO): void {
    if (
      lifeCycleRow.refurbStatus != 'ON ROUTE' &&
      lifeCycleRow.refurbStatus != 'ENGINEIUS REQUESTED'
    )
      return;

    this.vehicleLifeCycleService.getAdditionalOrderInfo(lifeCycleRow.taskId).then((orderInfo) => {
      this.additionalOrderInfo = orderInfo;
      this.loadMap(orderInfo);
      this.orderInfoVisible = true;
    });
  }

  hideOrderInfo(): void {
    this.orderInfoVisible = false;
  }

  loadMap(orderInfo: IVehicleLifeCycleAdditionalOrderInfo) {
    this.mapLoading = true;

    const task = {
      pickupLocation: { latitude: orderInfo.fromLatitude, longitude: orderInfo.fromLongitude },
      dropoffLocation: { latitude: orderInfo.toLatitude, longitude: orderInfo.toLongitude },
    } as ITaskInfo;

    this.mapLink = this.mapService.getStaticMapPath(
      'roadmap',
      this.mapService.buildMarkersFromTask(task),
      '600x400',
      1,
      null,
      [orderInfo.polyline],
    );

    this.mapLoading = false;
  }

  selectTile(selectedStatuses: string[]): void {
    this.filterVal.filters.refurbStatuses.value = null;
    this.filterVal.first = 0;

    this.filterVal.filters.refurbStatuses = {
      value: selectedStatuses,
    };

    this.filter.next(this.filterVal);
  }

  getSiteStatusOverview(): void {
    this.vehicleLifeCycleService.getSiteStatusOverview().then((response) => {
      this.siteStatusOverview = response;
    });
  }

  showSiteDetails(): void {
    this.vehicleLifeCycleService.getSiteDetails().then((response) => {
      this.siteDetails = response;
      this.groupedSiteDetails = this.siteDetails.reduce((groups, siteDetail) => {
        const providerName = siteDetail.providerName;
        if (!groups[providerName]) {
          groups[providerName] = [];
        }
        groups[providerName].push(siteDetail);
        return groups;
      }, {});
    });

    this.siteDetailsVisible = true;
  }

  hideSiteDetails(): void {
    this.siteDetailsVisible = false;
  }

  getSiteDetailsForKey(key: string): IVehicleLifeCycleSiteDetails[] {
    return this.groupedSiteDetails[key];
  }
}
